var main = require('client_core/main');
main.baseFiles.menu = require('./components/menu');
main.baseFiles.base = require('./product/base');
module.exports = main;